import { Row } from "antd";

import { useMediaQuery } from "react-responsive";
import { FeedbackCard, InfoCard, NotificationsCard, TransactionsTable } from "./components";

export default function Profilo({ }) {
    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    return (
        <Row style={{ padding: isLargeScreen ? "20px 50px" : "10px 10px" }}>
            <Row style={{ width: "100%", marginTop: "10px" }}></Row>
            <Row style={{ width: "100%", marginTop: "25px" }} justify="center">
                <InfoCard />
            </Row>
            <Row style={{ marginTop: "25px", width: "100%" }}>
                <NotificationsCard />
            </Row>
            <Row style={{ marginTop: "25px", width: "100%" }}>
                <FeedbackCard />
            </Row>
        </Row>
    );
}
